import React from "react";
import { setDisplayName } from "recompose";
import MediaQuery from "react-responsive";

export default setDisplayName("HiddenOn")(({ children, width }) => (
  <MediaQuery minWidth={width + 1}>{children}</MediaQuery>
));
